module.exports = __webpack_public_path__ + "static/img/icon-doge.b72076d4.png";